import fetcher from "lib/fetcher";
import useSWRImmutable from "swr/immutable";

const key = "/api/v2/templates";

export const getReviewsKey = (id, page = 1) => {
  return "/api/v2/templates/" + id + "/reviews?page=" + page;
};

export type ReviewImage = {
  src: string;
};

export type Review = {
  id: string;
  title: string;
  score: number;
  content: string;
  name: string;
  first_name: string;
  last_name: string;
  likes: number;
  date: string;
  images: ReviewImage[];
  created_at: string;
  updated_at: string;
};

export default function useReviews(templateId, page) {
  const key = getReviewsKey(templateId, page);
  const { data, error, mutate } = useSWRImmutable<{
    reviews: Review[];
    pagination: any;
  }>(key, (key) => {
    return fetcher({ url: key }).then((res) => {
      return res;
    });
  });

  return {
    reviews: data?.reviews,
    pagination: data?.pagination,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}
